import * as D from './deps';

export function getBrowseDirectory({ path, directoryId, offset, feedType }) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.PLS_GET_DIRECTORY,
    content: {
      deviceType: 'web',
      path,
      directoryId,
      offset,
      feedType,
    },
  });
}
